export default ({ index, appConfig }) => `
<style>
    [data-odr-widget="${index}"] {
        --odr-input-borderBottom: none !important;
        --odr-base-font-family: arial !important;
    }

    [data-odr-dummy="${index}"] ~ [data-odr-place] {
        display: none;
    }
</style>
<div data-odr-wrap="${index}" class="odr-search-widget ${appConfig.rtl ? 'odr-search-widget_rtl' : ''}" style="max-width: ${appConfig.searchMaxWidth}px !important">
    <div style="max-width: ${appConfig.searchMaxWidth}" class="odr-search-widget__gray-block ${appConfig.searchNoBackground ? 'odr-search-widget__gray-block_transparent' : ''}">
        <div class="odr-search-widget__title">${appConfig.searchTitle}</div>
        <div class="odr-search-widget__row">
            <div class="odr-search-widget__column-field">
                <div class="odr-search-widget__field">
                    <span data-odr-dummy="${index}">
                        <input class="odr-search-widget__input" data-odr-search="${index}" type="text" placeholder="${appConfig.searchPlaceholder}"/>
                        <div class="odr-search-widget__progress" data-odr-widget="${index}">
                            <div class="odr-linear-progress">
                                <div class="odr-linear-progress__bar"></div>
                            </div>
                        </div>
                    </span>
                    <div data-odr-place="">
                        <span data-odr-container="${index}"></span>
                    </div>
                </div>
            </div>
            <div class="odr-search-widget__column-button">
                <button data-qa="search${index}.submit" form="odrSearch${index}" type="submit" class="odr-search-widget__submit">
                    <svg class="odr-svg" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
                    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
                </button>
            </div>
        </div>
        ${appConfig.searchShowTerms ? '<div class="odr-search-widget__hint-block">By doing a search, you agree to <a class="odr-search-widget__hint-link" href="https://www.odoro.com/terms" target="_blank">Terms of Service</a> and <a class="odr-search-widget__hint-link" href="https://www.odoro.com/privacy" target="_blank">Privacy Policy</a>.</div>' : ''}
    </div>
</div>`;
